import { Box, Button, Chip, Typography, styled } from "@mui/material";

export const FilteredByLabel = styled(Typography)({
  fontFamily: "Inter, sans-serif",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  letterSpacing: 0,
  color: "#000000",
});

export const ActiveFilterChipsContainer = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "10px",
  margin: "0 15px 15px",
});

export const FilterChip = styled(Chip)({
  height: "25px",
  borderRadius: "5px",
  backgroundColor: "#D7ECFD",
  color: "#14142B",
  fontFamily: "Inter, sans-serif",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  letterSpacing: 0,
  paddingTop: "3px",
  paddingRight: "5px",
  paddingBottom: "2px",
  paddingLeft: "9px",
  "& .MuiChip-label": {
    padding: 0,
    fontFamily: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
  },
  "& .MuiChip-deleteIcon": {
    margin: "0 0 0 10px",
  },
});

// CSS X (two rotated bars) instead of an image asset so it stays crisp at 8px.
export const CloseIconGlyph = styled("span")({
  position: "relative",
  display: "inline-block",
  width: "8px",
  height: "8px",
  cursor: "pointer",
  opacity: 1,
  transition: "opacity 0.15s ease",
  "&:hover": {
    opacity: 0.6,
  },
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "10px",
    height: "1.2px",
    backgroundColor: "#14142B",
  },
  "&::before": {
    transform: "translate(-50%, -50%) rotate(45deg)",
  },
  "&::after": {
    transform: "translate(-50%, -50%) rotate(-45deg)",
  },
});

export const ClearAllButton = styled(Button)({
  minWidth: "55px",
  height: "24px",
  padding: "0 8px",
  marginLeft: "8px",
  color: "#4B9EF9",
  backgroundColor: "transparent",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  whiteSpace: "nowrap",
  boxShadow: "none",
  textDecorationLine: "underline",
  textDecorationColor: "#4B9EF9",
  textUnderlineOffset: "4px",
  "&:hover": {
    backgroundColor: "#EAF1FE",
    boxShadow: "none",
  },
});
